import type { FigmaFileListing, FigmaImportStarted } from '../../../shared/figma'
import type { FigmaTransfer } from '../../../shared/figmaExport'
import { req, type IntegrationsStatus } from '../../lib/api'

/** The `figma` slice of the integrations status, as the server shapes it. */
export interface FigmaIntegrationStatus {
  /** true: connect through Figma's consent screen; false: paste a token */
  oauth: boolean
  connected: boolean
  accountName?: string
  via?: 'oauth' | 'token'
  connectedAt?: number
}

export function figmaStatusOf(status: IntegrationsStatus): FigmaIntegrationStatus {
  return (status.figma ?? { oauth: false, connected: false }) as FigmaIntegrationStatus
}

export const figmaApi = {
  exportFrames: (canvasId: string, frameIds: string[], signal?: AbortSignal) =>
    req<FigmaTransfer>(`/api/canvases/${canvasId}/figma/export`, {
      method: 'POST',
      body: JSON.stringify({ frameIds }),
      signal,
    }),
  connectToken: (token: string) =>
    req<IntegrationsStatus>('/api/integrations/figma/token', { method: 'POST', body: JSON.stringify({ token }) }),
  disconnect: () => req<IntegrationsStatus>('/api/integrations/figma', { method: 'DELETE' }),
  /* figma import: list a link's frames for review, then start landing the
     chosen ones — the import continues as a task after the response */
  listFrames: (canvasId: string, url: string) =>
    req<FigmaFileListing>(`/api/canvases/${canvasId}/figma/frames`, { method: 'POST', body: JSON.stringify({ url }) }),
  importFrames: (canvasId: string, fileKey: string, frames: { id: string; page: string }[]) =>
    req<FigmaImportStarted>(`/api/canvases/${canvasId}/figma/import`, {
      method: 'POST',
      body: JSON.stringify({ fileKey, frames }),
    }),
}
